import React from "react";

import Text from "@src/sharedComponents/Typography/Text";

const AssetClassesHelperText = () => {
  return (
    <>
      <li>
        <Text variant="bodySmall">
          {`In columns L and M, you can optionally assign an asset class to a holding. If it's a default asset class, fill in column L with the name of the default asset class and leave column M blank. A list of the default asset classes can be seen in the “Asset Classes” dropdown when creating or editing a portfolio. If it's a custom asset class (existing or new), fill in column L with the name of the custom asset class and put "Equity", "FixedIncome", "CashEquivalents", or "Other" in column M.`}
        </Text>
      </li>
    </>
  );
};

export default AssetClassesHelperText;
